const SESSION_KEY = 'vue3-supplies-session'

export { SESSION_KEY }
